import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormBuilder, Validators } from '@angular/forms';

import { Router } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { DialogActionService } from 'src/app/Services/dialog-actions.service';
import { SharedService } from 'src/app/Services/shared.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
declare const popup: any, snackbar: any;
declare const Swal;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  username = '';
  password = '';
  confirm_password = '';
  showSpinner: boolean;
  inputType = 'password';
  adPswdSt: boolean;
  adEmail: string;
  isShowContent: any;
  isShowEyes = true;
  loginForm: any;
  submitted = false;

  forgotName: string;
  isForget: any;
  isShowForgotError = false;
  noFields: boolean = false;
  public fieldSubmitted: boolean = false;
  public enableInvalidUser: boolean = false;
  public userRestrictionData: any = {}

  constructor(
    private router: Router,
    public storage: StorageService,
    public api: ApiService,
    public shared: SharedService,
    public swal: SweetAlert,
    public dialogService: DialogActionService,
    private formBuilder: FormBuilder
  ) {

  }
  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(4)]]
    });
    // this.getAdminCheckData();
    this.shared._subject.next({
      isShowNavbar: true
    });

  }
  get f() { return this.loginForm.controls; }


  // Ender button
  enterToLogin(e) {
    if (e.keyCode === 13) {
      this.login();
    }
  }
  //  Login function
  async login() {
    // this.sweet.swalFunction('success', 'Deleted', 'Activity has been deleted', 2000)
    const isValidEmail = this.username.match('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$');
    if (isValidEmail && this.password) {
      this.api.transportManagerLogin({ email: this.username, password: this.password })
        .then(async (res: any) => {
          if (res.status == 'success') {
            if (res.appLicenseMessage) {
              // this.swal.swalFunction('success', res.status, res.appLicenseMessage, 10000)
              Swal.fire({
                title: this.swal.titleCase(res.status),
                text: res.appLicenseMessage,
                icon: 'warning',
                confirmButtonColor: '#f0ad4e',
                confirmButtonText: 'Okay',
              }).then(async (result) => {
                if (result.isConfirmed) {
                  this.shared._subject.next({
                    type: 'navBar',
                    isShowNavbar: false
                  });

                  this.storage.setData({ userType: 'transport_manager', token: res.token, isMapActiveVeh: true }); //isMapActiveVeh for active vehicles in TM Dashboard Map
                  await this.api.GetCurUserOrg({}).then((res: any) => {
                    if (res.status == 'success') {
                      let userInfo = res.data[0];
                      if (userInfo && userInfo['fieldMap']) {
                        this.storage.setData({ userInfo: userInfo });
                        this.userRestrictionData = userInfo['fieldMap'];
                        let menus = Object.keys(this.userRestrictionData);
                        let activeMenu = '';
                        for (let i = 0; i < menus.length; i++) {
                          if (this.userRestrictionData[menus[i]].checked || this.userRestrictionData[menus[i]].indeterminate) {
                            if (menus[i] == 'Dashboard') {
                              activeMenu = 'dashboard';
                            } else if (menus[i] == 'SOS Panel') {
                              activeMenu = 'sospanel/map-view';
                            } else if (menus[i] == 'Request') {
                              activeMenu = 'request/list-request';
                            } else if (menus[i] == 'Route / Rostering') {
                              activeMenu = 'rostering';
                            } else if (menus[i] == 'Reports') {
                              activeMenu = 'reports/report-dashboard';
                            } else if (menus[i] == 'Information') {
                              activeMenu = 'information';
                            } else if (menus[i] == 'Support Desk') {
                              activeMenu = 'support-desk';
                            }
                            break;
                          }
                        }
                        setTimeout(() => {
                          // console.log("this.storage.get('userInfo');--- ",this.storage.get('userInfo'))
                          this.router.navigate(['/organization/transport-manager/' + activeMenu]);
                        }, 400);
                      } else {
                        this.storage.setData(userInfo['fieldMap'] = {
                          "Dashboard": {
                            "name": "Dashboard",
                            "checked": true,
                            "menu1": {
                              "Vehicle Information": {
                                "name": "Vehicle Information",
                                "checked": true
                              }
                            }
                          }
                        });

                        setTimeout(() => {
                          this.router.navigate(['/organization/transport-manager/dashboard']);
                        }, 400);
                      }
                    }
                  }).catch((err) => {
                    console.log(err);
                  });
                }
              });
            } else {
              this.shared._subject.next({
                type: 'navBar',
                isShowNavbar: false
              });

              this.storage.setData({ userType: 'transport_manager', token: res.token, isMapActiveVeh: true }); //isMapActiveVeh for active vehicles in TM Dashboard Map
              await this.api.GetCurUserOrg({}).then((res: any) => {
                if (res.status == 'success') {
                  let userInfo = res.data[0];
                  console.log("USEEEEEEEEEEEEEEE",res);
                  if (userInfo && userInfo['fieldMap']) {
                    this.storage.setData({ userInfo: userInfo });
                    this.userRestrictionData = userInfo['fieldMap'];
                    let menus = Object.keys(this.userRestrictionData);
                    let activeMenu = '';
                    for (let i = 0; i < menus.length; i++) {
                      if (this.userRestrictionData[menus[i]].checked || this.userRestrictionData[menus[i]].indeterminate) {
                        if (menus[i] == 'Dashboard') {
                          activeMenu = 'dashboard';
                        } else if (menus[i] == 'SOS Panel') {
                          activeMenu = 'sospanel/map-view';
                        } else if (menus[i] == 'Request') {
                          activeMenu = 'request/list-request';
                        } else if (menus[i] == 'Route / Rostering') {
                          activeMenu = 'rostering';
                        } else if (menus[i] == 'Reports') {
                          activeMenu = 'reports/report-dashboard';
                        } else if (menus[i] == 'Information') {
                          activeMenu = 'information';
                        } else if (menus[i] == 'Support Desk') {
                          activeMenu = 'support-desk';
                        }
                        break;
                      }
                    }
                    setTimeout(() => {
                      // console.log("this.storage.get('userInfo');--- ",this.storage.get('userInfo'))
                      this.router.navigate(['/organization/transport-manager/' + activeMenu]);
                    }, 400);
                  } else {
                    this.storage.setData(userInfo['fieldMap'] = {
                      "Dashboard": {
                        "name": "Dashboard",
                        "checked": true,
                        "menu1": {
                          "Vehicle Information": {
                            "name": "Vehicle Information",
                            "checked": true
                          }
                        }
                      }
                    });

                    setTimeout(() => {
                      this.router.navigate(['/organization/transport-manager/dashboard']);
                    }, 400);
                  }
                }
              }).catch((err) => {
                console.log(err);
              });
            }

          } else {
            // this.openLogoutModal(res);
            if (res.appLicenseMessage) {
              // this.swal.swalFunction('error', res.status, res.appLicenseMessage, 10000)
              Swal.fire({
                title: this.swal.titleCase(res.status),
                text: res.appLicenseMessage,
                icon: 'error',
                showCancelButton: true,
                showConfirmButton: false,
                cancelButtonColor: '#757575ba',
                cancelButtonText: 'Close',
              }).then(async (result) => {
                if (result.dismiss === Swal.DismissReason.cancel) {
                }
              });
            } else {
              this.swal.swalFunction('error', res.status, res.message, 2000)
            }
          }
        })
        .catch((err) => console.log(err));
    } else if (this.password) {
      if (isValidEmail == null && this.username != '') {
        snackbar(`<span class="text-warning"> Invalid username</span>`);
      } else if (isValidEmail == null && this.username == '') {
        snackbar(`<span class="text-warning"> username required</span>`);
      }
    } else if (this.username != '' && isValidEmail != null) {

      snackbar(`<span class="text-warning"> Password required </span>`);
    } else {
      snackbar(`<span class="text-warning"> Username and password required </span>`);
    }
  }
  openLogoutModal(value) {
    const userId = 'user01';
    const config = {
      name: value.message,
      title: value.status.charAt(0).toUpperCase() + value.status.slice(1).toLowerCase(),
      description: value.message,
      actionButtonText: '',
      userId
    };
    this.dialogService.popup(config);
  }

  //  Space bar disable
  keychange(event) {
    if (event.keyCode == 32) {
      this.username = '';
    }
  }

  //  Show password icon
  viewPassword() {
    this.isShowEyes = !this.isShowEyes;
    this.inputType = this.inputType == 'text' ? 'password' : 'text';
  }


  getAdminCheckData() {
    this.api.getMasterLoginData({})
      .then((res: any) => {
        if (res.status) {
          this.adPswdSt = res.adminPasswordSet;
          this.adEmail = res.email;
          if (res.adminPasswordSet) {
            this.storage.setData({ adEmail: res.email });
            // this.router.navigate(["master/active-link"]);
          }
        } else {
          alert(res.status);
        }
        //console.log(res.adminPasswordSet, res.email, res.status);
      }).catch((err: any) => {
        console.log(err);
      });
  }

  forgotEmailValid() {
    this.noFields = false;
    this.enableInvalidUser = false;
    // this.forgotEmail.match('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$')
    if (this.forgotName) {
      this.isForget = this.forgotName.match('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$');
    }
    if (this.fieldSubmitted) {
      if (this.isForget) {
        this.isShowForgotError = false;
      } else {
        this.isShowForgotError = true;
      }
    }
  }

  sentMail() {
    this.fieldSubmitted = true;
    this.forgotEmailValid();
    if (!this.forgotName) {
      this.noFields = true;
      return;
    } else {
      this.noFields = false;
      if (this.forgotName) {
        // console.log(this.forgotName);
        this.isForget = this.forgotName.match('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$');
        // this.close()
      } else {
        this.isShowForgotError = true;
      }
      if (this.isForget) {
        const obj = {
          email: this.forgotName
        };
        // console.log(obj);
        this.api.orgForgotPassword(obj).then((res: any) => {
          if (res.status == 'success') {
            this.swal.swalFunction(res.status, res.status, res.message, 2000);
            document.getElementById('forgetCancel').click();
          }
          if (res.status == 'failure') {
            //console.log('failure', res.message);
            this.enableInvalidUser = true;
            // snackbar(`<span class="text-warning">Invalid Email</span>`);
          }
        }).catch((err) => {
          console.log(err);
        });
      } else { return; }
    }
  }
  close() {
    this.forgotName = '';
    this.isShowForgotError = false;
    this.fieldSubmitted = false;
    this.noFields = false;
    this.enableInvalidUser = false;
  }

  onSubmit() {
    this.submitted = true;

  }
}

